<template>
  <div class="counters-background">
    <BaseImage
      src="/counters/background.webp"
      alt="background"
      class="counters-background__image"
      object-fit="cover"
    />
    <div class="counters-background__overlay" />
  </div>
</template>

<script setup lang="ts">
import { BaseImage } from '~/shared/ui'
</script>

<style lang="scss" scoped>
.counters-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;

  &__image {
    width: 100%;
    height: 100%;
    filter: blur(2.5px);
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(0 0 0 / 30%);
    z-index: 1;
  }
}
</style>
